import { render, staticRenderFns } from "./BaseWindow.vue?vue&type=template&id=6009d4db&"
import script from "./BaseWindow.vue?vue&type=script&lang=js&"
export * from "./BaseWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports